import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { EmbeddingContext, VisualExperience } from 'amazon-quicksight-embedding-sdk/dist';
import { Logger } from 'common/utility/logger/logger';
import { take } from 'rxjs';
import { Environment } from 'src/environments/environment';

@Component({
  selector: 'ems-visual',
  standalone: false,
  templateUrl: './visual.component.html'
})
export class VisualComponent {
  constructor(private http: HttpClient) { }

  loadingError = false;

  dashboardId: any
  sheetId: any
  visual: VisualExperience | undefined;


  ngOnInit() {
    this.GetVisualURL();
  }

  public GetVisualURL() {
    const url: string = Environment.ApiUrl
    this.http.get(url)
      .pipe(
        take(1),
      )
      .subscribe((data: any) => {
        const reportUrl: string = data.url
        Logger.debug("Connecting to reports with url:", reportUrl)
        this.Visual(reportUrl)
      });
  }

  public async Visual(embeddedURL: any) {
    var containerDiv = document.getElementById("visualContainer") || '';
    const frameOptions = {
      url: embeddedURL,
      container: containerDiv,
      height: "850px",
      width: "100%",
      resizeHeightOnSizeChangedEvent: true,
      sandbox: "allow-same-origin"
    }

    const contentOptions = {
      parameters: this.getParameters(1)
    }

    const embeddingContext: EmbeddingContext = await createEmbeddingContext();
    this.visual = await embeddingContext.embedVisual(frameOptions, contentOptions);
    // const filterGroups: Array<FilterGroup> = await this.visual.getFilterGroups();

    Logger.debug("Visual ID:", this.visual)
    // Logger.debug("FilterGroups:", filterGroups)
  }

  public MonthChanged(event: any): void {
    const month: number = event?.target?.value ?? 1

    Logger.debug("Month Changed:", event?.target?.value)
    this.visual?.setParameters(this.getParameters(month))
  }

  private getParameters(startMonth: number): Array<any> {
    const month: string = String(startMonth ?? 1).padStart(2, '0')
    return [
      {
        Name: 'StartDate',
        Values: [`2016/${month}/01`],
      }
    ]
  }
}
